import Mint from './Mint'
import Team from './Team'

//This functional component embodies the Mint functional component
function Body(props) {

    //This function gets the number of mints and passes this to an external,
    //parent function
    const addCount = (num, clickState) => {
        props.onGet(num, clickState)
    }

    //Thse functions call an external, parent function and returns value for use
    async function onAccessMintFunc () {
        return (props.onAccessMint)
    }

    async function onCheckDisconnected () {
        return (props.onAccessDisconnected)
    }

    return (
        <div className='body'>
            <h2 id='welcome'>Welcome to the home of The Mystic Creatures...</h2>
            <h4 id='detail'>
                <p>A group of soldiers on a martian travel discovered some</p>
                <p>weird creatures and brought them back down to earth.</p>
                <p>You just can't understand!</p>
            </h4>
            <img id='website_gif' src={"https://ipfs.io/ipfs/QmZhGo6cmE4kjmrQWTzdNaUS1wtPEtMAJ1drGEJzF3ZT3L/"} 
            alt='gif'/>
            <Mint onGetAccessValue={onAccessMintFunc} onCheckDisconnectedVal={onCheckDisconnected} onAdd={addCount} text='Minted' onFetch={() => (props.onReadAddress)}/>
            <Team />
        </div>
    )
}

export default Body